import React, { createContext, Fragment, useCallback, useContext, useEffect, useState } from "react";

import styles from "../View/CustomerFeedback/FeedbackModal.module.css";
import FeedbackModalButton from "../View/CustomerFeedback/FeedbackModalButton";
import { useAuth } from "./AuthContext";
import { shouldShowFeedback } from "../View/CustomerFeedback/feedbackApi";
import { feedbackSvg } from "../assets/imageImport";

const FeedbackContext = createContext();

export const FeedbackProvider = ({ children }) => {
  const { userId, isAuthenticated } = useAuth() || {};

  const [isOpen, setIsOpen] = useState(false);
  const [source, setSource] = useState("manual");
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    const pathName = window.location.pathname.toLowerCase();
    setShowButton(false);
    // if (pathName.includes("/billinfo") || pathName.includes("/home") || pathName.includes("/myaccount")) {
    //   setShowButton(true);
    // } else setShowButton(false);
  }, [window.location.pathname]);

  const showFeedback = useCallback(
    async (options = {}) => {
      const { source: src = "manual", gated = false } = options;

      if (!gated) {
        setSource(src);
        setIsOpen(true);
        return;
      }

      // Server owns suppression (progressive back-off / submitted). Identity rides
      // in the JWT, so no userId is passed.
      const show = await shouldShowFeedback();
      if (show) {
        setSource(src);
        setIsOpen(true);
      }
    },
    [userId],
  );

  const close = useCallback(() => setIsOpen(false), []);
  const feedbackPage = ["/home", "/myaccount", "/billinfo", "billInfo"];

  return (
    <FeedbackContext.Provider value={{ showFeedback }}>
      {children}

      {isAuthenticated && showButton && (
        <Fragment>
          <a
            role="button"
            tabIndex={0}
            className="floating-announcement-btn"
            onClick={() => showFeedback()}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                showFeedback();
              }
            }}
            aria-label="Announcements"
          >
            <span className="announcement-text">Help us improve your experience!</span>
            <img src={feedbackSvg} alt="" />
            <span className="announcement-rays" aria-hidden="true" />
          </a>
        </Fragment>
      )}

      <FeedbackModalButton isOpen={isOpen} source={source} onClose={close} />
    </FeedbackContext.Provider>
  );
};

export const useFeedback = () => useContext(FeedbackContext);
